import { CardContent, Grid } from '@material-ui/core'
import { IOProps } from 'react-compose-io'
import { FormProvider } from 'react-hook-form'
import { CustomActionsButtons } from '../../../../components/CustomActionsButtons'
import { FormularioRegra } from '../../../../components/CustomFormControl/FormularioRegra/index'
import { CustomSimpleTable } from '../../../../components/CustomSimpleTable'
import Modal from '../../../../components/Modal/Modal'
import { NOTAFISCAL, NOTAFISCAL_MODAL } from '../../../../constants/notaFiscal'
import { UploadPlanilha } from '../UploadPlanilha/index'
import { Container, Main, Subtitle, TableWrapper, Upload } from './RegraNotaFiscalForm.styles'
import { Tipografia } from '../../../../components/Tipografia'
import { RegraNotaFiscal } from '../../../../types/notaFiscalApiTypes'
import { RegraNotaFiscalFormIO } from './RegraNotaFiscalForm.IO'
import { PreVisualizarParametroNotaFiscal } from '../../../../components/PreVisualizarParametroNotaFiscal'

export type RegraNotaFiscalFormProps = {
  regraNotaFiscalEditar?: RegraNotaFiscal
}

export default function RegraNotaFiscalFormView({ _io }: IOProps<RegraNotaFiscalFormIO, RegraNotaFiscalFormProps>) {
  return (
    <>
      <Main>
        <Tipografia variant="h5">{NOTAFISCAL.titulo}</Tipografia>
        <Container>
          <CardContent>
            <Tipografia variant="h6">{NOTAFISCAL.cartaoTitulo}</Tipografia>
            <Subtitle>{NOTAFISCAL.cartaoSubtitulo}</Subtitle>
            <Upload>
              <UploadPlanilha setArquivoId={_io.setArquivoId} />
            </Upload>
          </CardContent>
        </Container>
        <Container>
          <CardContent>
            <Tipografia variant="h6">{_io.regraId ? NOTAFISCAL.formularioTituloEditarRegra : NOTAFISCAL.formularioTituloNovaRegra}</Tipografia>
            <Subtitle>{NOTAFISCAL.formularioSubtitulo}</Subtitle>
            <FormProvider {..._io.parametrosForm}>
              <form onSubmit={_io.parametrosForm.handleSubmit(_io.enviarDadosFormulario)}>
                <FormularioRegra
                  isEdicao={_io.regraId ? true : false}
                  mudarStatusParaAtivo={_io.mudarStatusParaAtivo}
                  ativo={_io.switchAtivo}
                  condicaoLista={_io.condicaoList}
                  acaoLista={_io.acaoList}
                  grupoRegraLista={null}
                  cabecalhosPlanilha={_io.fieldDado}
                />
                <CustomActionsButtons
                  hasPreview
                  hasCancel
                  hasSave
                  hasSaveContinue={!_io.regraId}
                  handlePreview={_io.handlePreview}
                  handleCancelar={_io.handleCancelar}
                  handleSave={() => _io.setSave(false)}
                  handleSaveContinue={() => _io.setSave(true)}
                />
              </form>
            </FormProvider>
          </CardContent>
        </Container>
        <Modal
          title={NOTAFISCAL_MODAL.titulo}
          openModal={_io.openModal}
          fullWidth={false}
          maxWidth={false}
          onClose={_io.handleCloseModal}
          onAction={_io.handleCloseModal}
          hiddenButton
        >
          <Grid item sm={12}>
            <TableWrapper>
              <CustomSimpleTable cabecalhos={['PedidoPlanilha', 'Valor']}>
                {_io.preVisualizar != undefined ? <PreVisualizarParametroNotaFiscal row={_io.preVisualizar} /> : null}
              </CustomSimpleTable>
            </TableWrapper>
          </Grid>
        </Modal>
      </Main>
    </>
  )
}
